const DATA = {
	PACKETS: [
		{
			name: "Module One",
			activities: [
				{
					link: "/quiz",
					name: "Quiz",
					icon: "quiz.png",
					points: 5,
					progressRef: "quiz",
					data: {
						taskDescription: "Answer the question and get 5 points",
						question: "What is your primary goal with live events?",
						answer1: "Finding prospective customers",
						answer2: "Conversations with customers",
						answer3: "Networking",
						answer4: "Product awareness",
						popup: "Thank you! We'll keep that in mind.",
					},
					id: 1,
					packet_id: "packet_1",
				},
				// {
				// 	link: "/quiz",
				// 	name: "Quiz",
				// 	icon: "quiz.png",
				// 	points: 5,
				// 	progressRef: "quiz",
				// 	data: {
				// 		taskDescription: "Answer the question and get 5 points",
				// 		question: "What is your preferred drink?",
				// 		answer1: "Gin",
				// 		answer2: "Whiskey",
				// 		answer3: "Beer",
				// 		answer4: "It's a secret",
				// 		popup: "Thank you! We'll keep that in mind.",
				// 	},
				// 	id: 1,
				// 	packet_id: "packet_1",
				// },
				{
					link: "/mint",
					name: "Mint your NFT",
					icon: "mint.png",
					points: 10,
					progressRef: "mint",
					data: {
						taskDescription: "You can earn 10 points for minting your NFT",
					},
					id: 6,
					packet_id: "packet_1",
				},
				{
					link: "/video",
					name: "Watch Video",
					icon: "video.png",
					points: 5,
					progressRef: "video",
					data: {
						taskDescription:
							"for watching this video you can have up to 5 points depending on how long you've watched.",
						url: "https://vimeo.com/738487002",
					},
					id: 2,
					packet_id: "packet_1",
				},
			],
			completed: false,
			badge: {
				name: "Module 1",
				img: "../assets/module-one.png",
				is_unlocked: false,
				is_awarded: false,
			},
			packet_id: "packet_1",
		},
		{
			name: "Module Two",
			activities: [
				{
					link: "/bio",
					name: "Complete your profile",
					icon: "bio.png",
					points: "10",
					progressRef: "bio",
					data: {
						taskDescription:
							"You can earn 10 points for completing your profile",
					},
					id: 5,
					packet_id: "packet_2",
				},
				{
					link: "/ar",
					name: "AR Photobooth",
					icon: "ar.png",
					points: 10,
					progressRef: "ar",
					data: {
						taskDescription:
							"You can earn 10 points for completing this AR experience",
					},
					id: 7,
					packet_id: "packet_2",
				},

				{
					link: "/download",
					name: "Download PDF",
					icon: "pdf.png",
					points: 5,
					progressRef: "pdf",
					data: {
						taskDescription: "You can earn 5 points for downloading PDF.",
					},
					id: 4,
					packet_id: "packet_2",
				},
			],
			completed: false,
			badge: {
				name: "Module 2",
				img: "../assets/module-two.png",
				is_unlocked: false,
				is_awarded: false,
			},
			id: "2-1",
		},
		// {
		// 	name: "Social Community",
		// 	activities: [
		// 		{
		// 			link: "/quiz",
		// 			name: "Quiz",
		// 			points: 10,
		// 			progressRef: "quiz",
		// 			data: {
		// 				taskDescription: "Answer the question and get 5 points",
		// 				question: "Which month has 28 days?",
		// 				answer1: "January",
		// 				answer2: "February",
		// 				answer3: "May",
		// 				answer4: "August",
		// 				popup: "You know, all of them have at least 28...",
		// 			},
		// 			id: 7,
		// 			packet_id: "packet_3",
		// 		},
		// 	],
		// 	completed: false,
		// 	id: "3-1",
		// },
	],

	REWARDS: {
		// {
		// 	id: 0,
		// 	name: "FT Logo NFT",
		// 	price: 50,
		// 	image: "ft-logo.png",
		// },
		reward_one: {
			id: "reward-one",
			name: "$1000 Notion credit",
			price: 25,
			image: "notion.png",
			coupon: "F6SBlackFriday",
			redeemed: false,
		},
		reward_two: {
			id: "reward-two",
			name: "Personalized AI gift",
			price: 40,
			image: "ai.png",
			coupon: "",
			redeemed: false,
		},
	},

	PROGRESS: {
		packet_1: {
			id: "9090909d9ru",
			activities: {
				quiz: {
					completed: false,
					answer: "",
				},
				mint: {
					completed: false,
				},
				video: {
					completed: false,
				},
			},
			badge: {
				name: "World",
				img: "ModuleOne",
				is_unlocked: false,
				is_awarded: false,
			},
			packet_activated: true,
			packet_completed: false,
			package_points: 0,
		},

		packet_2: {
			id: "9090909d9kz",
			activities: {
				bio: {
					completed: false,
				},
				ar: {
					completed: false,
				},
				pdf: {
					completed: false,
				},
			},
			badge: {
				name: "Identity",
				img: "../assets/module-two.png",
				is_unlocked: false,
				is_awarded: false,
			},
			packet_activated: false,
			packet_completed: false,
			package_points: 0,
		},
		// quiz1_completed: false,
		// video_completed: false,
		// pdf_completed: false,
		// mg_completed: false,
		// quiz2_completed: false,
		// packet1_completed: false,
		// packet2_completed: false,

		packets: [
			{
				name: "World Building",
				activities: [
					{
						name: "Quiz",
						activity_completed: false,
						id: 1,
					},
				],
				packet_completed: false,
			},
			{
				name: "Identity Currency",
				activities: [
					{
						name: "Ar",
						activity_completed: false,
						id: 2,
					},
				],
				packet_completed: false,
			},
		],
	},
};

export default DATA;
